export default __webpack_public_path__ + "static/media/remove.9c6ce992.svg";